<template>
	<div class="video-play-wrap" @click.stop.self="hideVideo">
		<div class="prism-player" id="J_prismPlayer"></div>
	</div>
</template>

<script>
	export default {
		name: "video-play",
		props: ["vid"],
		created() {
			var _this = this;
			console.log(this.vid);
			setTimeout(function() {
				new Aliplayer({
					id: 'J_prismPlayer',
					width: '100%',
					autoplay: false,
					preload: false,
					vid: _this.vid,
					accessKeyId: '\x4c\x54\x41\x49\x72\x47\x61\x72\x45\x36\x73\x41\x62\x4d\x56\x73',
					securityToken: '\x62\x64\x65\x66\x69\x6b\x6d\x6e\x70\x71\x78\x79\x30\x33\x36\x37\x38\x39',
					accessKeySecret: '\x43\x78\x39\x79\x61\x43\x70\x79\x37\x39\x51\x35\x54\x6e\x59\x64\x58\x38\x4e\x57\x6a\x6d\x32\x70\x6e\x34\x66\x6a\x44\x44',
					x5_type: "h5",
					x5_video_position: "center",
					x5_orientation: 'portrait'
				}, function(player) {
					console.log("ok")
				});
			},500)
		},
		mounted() {
			

		},
		methods: {
			hideVideo() {
				console.log("123");
				this.$emit("hideVideoPlay","hideVideoPlay");
			}
		}
	}
</script>

<style scoped>
	.video-play-wrap {
		width: 100vw;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, .7);
		z-index: 99;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	#J_prismPlayer {
		width: 100%;
		background: #fff;
	}
</style>


// WEBPACK FOOTER //
// src/components/Common/VideoPlay.vue